import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { deleteUserAccount, deleteuserotp } from "../../../../services/AuthService";
import { toast } from "react-toastify";
import { getEnvelopeSenderList } from "../../../../services/CommonService";
import Utils from "../../../../utils";

function DeleteUser({ email, firstName, lastName }) {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [senderList, setSenderList] = useState();

  const userDetails = {
    email,
    firstName,
    lastName,
  };

  // 🌟 Redirect to /sign-up when step is 4
  useEffect(() => {
    if (step === 4) {
      console.log("Redirecting to /sign-up...");
      navigate("/sign-up", { replace: true });
    }
  }, [step, navigate]);

  useEffect(() => {
    getEnvelopeSenderList()
      .then(response => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0 && senderData[0].id) {
          setSelectedUserId(Number(senderData[0].id));
        }
      })
      .catch(err => {
        toast.error("Failed to fetch sender list!");
      });
  }, []);

  const handleConfirmDelete = () => {
    if (!userDetails.email || !userDetails.firstName || !userDetails.lastName) {
      toast.error("Please fill in all fields!");
      return;
    }

    deleteuserotp({
      email: userDetails.email,
      first_name: userDetails.firstName,
      last_name: userDetails.lastName,
    })
      .then(() => setStep(3))
      .catch((err) => toast.error("Failed to send OTP: " + err.message));
  };

  const handleOtpSubmit = () => {
    deleteUserAccount({
      id: Number(selectedUserId)
    })
      .then(() => {
        toast.success("Your account has been deleted successfully!");
        localStorage.removeItem("CLIENT_LOCAL_STORE");
        Utils.logout();
      })
      .catch((err) => toast.error("Failed to delete account: " + err.message));
  };


  return (
    <div className="container d-flex flex-column justify-content-center align-items-center">
      <div className="">
        <div className="text-center p-4 mx-auto pt-4">
          <div className="card-header">
            <h5 className="card-title mb-2">Delete User</h5>
          </div>
          <div className="card-body">
            {step === 1 && (
              <>
                <p className="">Are you sure you want to delete your account?</p>
                <button className="btn btn-danger mt-4" onClick={() => setStep(2)}>
                  Yes, Confirm
                </button>
              </>
            )}
            {step === 2 && (
              <>
                <p className="pb-2">Enter your details to proceed:</p>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  className="form-control mb-2"
                  value={userDetails.firstName}
                  style={{ width: "300px" }}
                  readOnly
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  className="form-control mb-2"
                  value={userDetails.lastName}
                  style={{ width: "300px" }}
                  readOnly
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email ID"
                  className="form-control mb-2"
                  value={userDetails.email}
                  style={{ width: "300px" }}
                  readOnly
                />
                <button className="btn btn-save mt-2" onClick={handleConfirmDelete}>
                  Proceed
                </button>
              </>
            )}
            {step === 3 && (
              <>
                <p className="pb-2">Enter the OTP sent to your email:</p>
                <input
                  type="text"
                  className="form-control w-auto"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button className="btn btn-save mt-3" onClick={handleOtpSubmit}>
                  Submit OTP
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteUser;
